import React from 'react';

const Loading = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-black text-green-400 font-mono">
      <div className="text-2xl mb-4 animate-pulse">
        ⚔️ Loot<span className="text-purple-600">Layer</span> Loading...
      </div>
      <div className="relative w-64 h-2 bg-green-800 rounded-full overflow-hidden">
        <div className="absolute inset-0 bg-green-400 animate-load-bar rounded-full"></div>
      </div>
    </div>
  );
};

export default Loading;
